import React, { Suspense } from 'react';

import type { SettingsQuery$variables } from '../graphql/__generated__/SettingsQuery.graphql';
import { SettingConnectionFragment } from '../graphql/fragments/SettingConnectionFragment';
import { SettingFragment } from '../graphql/fragments/SettingFragment';
import { SettingListFragment } from '../graphql/fragments/SettingListFragment';
import { RemoteSettingsQuery } from '../graphql/RemoteSettingsQuery';
import { SettingsQuery } from '../graphql/SettingsQuery';
import DataLoader from '../table/DataLoader';

export interface SettingLoaderProps {
    onUpdateSettingData: (rows: any[], count: number, connectionId: string) => void;
    onUpdateRemoteSettingData: (rows: any[], count: number, connectionId: string) => void;
    updateSettingFetchKey?: number;
}

const SettingLoader: React.FC<SettingLoaderProps> = ({
    onUpdateSettingData,
    onUpdateRemoteSettingData,
    updateSettingFetchKey,
}) => {
    return (
        <Suspense>
            <DataLoader<SettingsQuery$variables, {}>
                query={SettingsQuery}
                fragmentList={SettingListFragment}
                fragment={SettingFragment}
                fragmentConnection={SettingConnectionFragment}
                nameQuery={'settings'}
                prefixFetchKey={'settingsFetchKey'}
                onUpdateData={onUpdateSettingData}
                externalFetchKey={updateSettingFetchKey}
            />
            <DataLoader<SettingsQuery$variables, {}>
                query={RemoteSettingsQuery}
                fragmentList={SettingListFragment}
                fragment={SettingFragment}
                fragmentConnection={SettingConnectionFragment}
                nameQuery={'settings'}
                prefixFetchKey={'settingsFetchKey'}
                onUpdateData={onUpdateRemoteSettingData}
                externalFetchKey={updateSettingFetchKey}
            />
        </Suspense>
    );
};

export default SettingLoader;
